import { useEffect, useRef, useState } from "react";
import SubHeader from "../../../components/SubHeader";
import MafiaService from "../../../services/mafiaService";
import { RootState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast, showInfoToast } from "../../../store/messageSlice";
import { IPlayer } from "../../../types/ILobbyView";
import { logout, setAdminRole, setPlayerName } from "../../../store/generalSlice";
import { setGameMode, setHostName, setLobbyPlayers } from "../../../store/gameSlice";
import './Lobby.scss';
import Footer from "../../../components/Footer";
import { useNavigate } from "react-router-dom";
import { IScenario } from "../../../types/IScenario";
import { GameModeEnum } from "../../../types/gameModeEnum";

function Lobby() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { serverName, playerName, role } = useSelector((state: RootState) => state.general);
    const { scenarios, selectedScenario} = useSelector((state: RootState) => state.editor);
    const [ currentScenario, setCurrentScenario] = useState<IScenario>();
    const { lobbyPlayers } = useSelector((state: RootState) => state.game);
    const [connection, setConnection] = useState<WebSocket>();

    useEffect(() => {
        const sc = scenarios.find(s => s.guid === selectedScenario);
        setCurrentScenario(sc);
    }, [selectedScenario])

    const pollLobby = async () => {
        MafiaService.LobbyView(serverName, (is_ok, payload) => {
            if (is_ok) {
                if(payload[0]?.toLowerCase() === 'game') {
                    dispatch(setGameMode(GameModeEnum.Day));                                        
                } else {
                    const players = payload[1].players as IPlayer[];
                    const hostName = payload[1].host_name;
    
                    dispatch(setLobbyPlayers(players));
                    dispatch(setHostName(hostName));
                    if (hostName === playerName) {
                        dispatch(setAdminRole());
                    }
                    if (playerName && players.map(p => p.name).indexOf(playerName || '') === -1) {
                        dispatch(showErrorToast(`You left the game`));
                        dispatch(logout());
                    }
                }

            } else {
                dispatch(showErrorToast(payload))
            }
        })
    };

    function start_websocket(): WebSocket {
        const ws = new WebSocket(`${process.env.REACT_APP_SERVER_URL}/lobby_ws/${serverName}`)

        // Connection opened
        ws.addEventListener("open", (event) => {
            console.debug("Connection open")
        })

        // Listen for messages
        ws.addEventListener("message", (event) => {
            console.debug("Message from server ", event.data)
            if(event.data.action) {
                switch(event.data.action.toLowerCase()) {
                    case "gamestarted":
                        dispatch(setGameMode(GameModeEnum.Day));
                        break;
                    default:
                        pollLobby();
                }
            } else {
                pollLobby();
            }
        })
        return ws;
    }

    useEffect(() => {
        pollLobby();

        if (connection == null) {
            const conn = start_websocket()
            setConnection(conn);
            return () => conn.close();
        }
    }, []);

    const onDiconnectClick = (e: any) => {
        console.log(`Disconnecting ${e.target.value}`);
        MafiaService.Disconnect(serverName!, e.target.value, (is_ok: boolean, payload: any) => {
            const name = e.target.value;
            if (is_ok) {
                dispatch(showInfoToast(`${name} disconnected.`))
            } else {
                dispatch(showErrorToast(`Error while diconnecting player ${name}. ${payload}`));
            }

            if (name === playerName) {
                dispatch(logout());
            }
        })
    }

    const onStartClick = () => {
        if(serverName && currentScenario && playerName) {
            MafiaService.StartGame(serverName, currentScenario, playerName, (is_ok, payload) => {
                if(is_ok)
                {
                    dispatch(setGameMode(GameModeEnum.Day));
                } else {
                    dispatch(showErrorToast(payload))
                }
            });
        } else {
            dispatch(showErrorToast(`Input data is missing`));
        }
        
    }

    const onScenarioClick = () => {
        navigate('/editor');
    }

    const getPlayerList = () => {
        return <div className="mafia-player-list">
            {lobbyPlayers.map((player, index) => {
                const oddEven = index % 2 == 1 ? 'odd reverted' : 'even';
                return <div key={index} className={`lobby-player-row ${oddEven}`}>
                    <div className={`pos`}>{index + 1}</div>
                    <div className={`name`}>{player.name}</div>
                    <div className={`button`}>
                        {(role === "admin" || player.name === playerName) && <button onClick={onDiconnectClick} value={player.name}>disconnect</button>}
                    </div>
                </div>
            })}
        </div>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>{serverName} Lobby {currentScenario ? `(${currentScenario.name})` : ''}</SubHeader>
            <div className="mafia-lobby-container mafia-list-container">
                {getPlayerList()}
            </div>
        </div>
        {role === 'admin' && 
        <Footer>
            <button onClick={onScenarioClick}>Scenario</button>
            <button onClick={onStartClick} className={currentScenario ? '' : 'disabled'}>Start</button>
        </Footer>}
    </div>

}

export default Lobby;